import { Component } from '@angular/core';
import { InsignStartComponent } from '@app/modules/insign-confirm/pages/insign-start/insign-start.component';
import { ActivatedRoute } from '@angular/router';
import { InsignConfirmService } from '@app/modules/insign-confirm/insign-confirm.service';
import { DRResponse, ResponseStatus } from '@app/shared/models/response';

@Component({
    templateUrl: './insign-finish.component.html',
    styleUrls: ['./insign-finish.component.scss']
})
export class InsignFinishComponent extends InsignStartComponent {

    public confirmationSuccess: boolean;

    get urlSuffix(): string {
        return 'callback';
    }

    constructor(protected route: ActivatedRoute, protected insignConfirmService: InsignConfirmService) {
        super(route, insignConfirmService);
    }

    protected handleResponse(response: DRResponse<any>): void {
        this.handleResponseFailure(response);

        if (response.status !== ResponseStatus.FAIL) {
            this.confirmationSuccess = true;
        }
    }
}
